import { createSvgComponent } from "../../icon/createSvgComponent";
import BookmarkOutline from "@core/icon/assets/bookmark-outline.svg";
export default createSvgComponent(BookmarkOutline);